import React from 'react'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { IProps } from './index'
import { CardWithImage } from '../CardWithImage/'
import { useModalContext } from 'marketing-site/src/components/context/ModalContext'
import { CTAButton } from 'marketing-site/src/library/elements/CTAButton'
import * as Utils from 'marketing-site/src/library/utils'
import { LegacyColor } from '../../utils'
import { TestimonialModal } from '../TestimonialModal'

export const CardWithModal: React.FC<IProps> = (props) => {
  const { setModalIsOpen, setModalContent } = useModalContext()

  const largeTestimonialProps = {
    quote: documentToHtmlString(props.description),
    name: props.title,
    jobTitle: props.body,
    portraitImgRef: {
      url: props.imageRef.url,
    },
    bgColor: LegacyColor.LightGray,
    alignLeft: true,
  }

  const invokeModal = () => {
    const Component = <TestimonialModal {...largeTestimonialProps} />
    setModalContent(Component)
    setModalIsOpen(true)
  }

  return (
    <div>
      <CardWithImage {...props} />
      <div className="modal-button">
        <CTAButton
          text={'Read bio'}
          onClick={() => invokeModal()}
          bgColor={Utils.CTATheme.LinkOnlyBlack}
          arrow={false}
        />
      </div>
      <style jsx>{`
        .modal-button {
          :global(span) {
            font-weight: normal;
            text-decoration: underline;
          }
        }
      `}</style>
    </div>
  )
}
